{
  "created_at": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Transfer Date",
      "width": 125,
      "isShownByDefault": true,
    },
  },
  "agreement_count": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "Agreements",
      "width": 80,
      "isShownByDefault": true,
    },
  },
  "seller_company": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "From",
      "isShownByDefault": true,
    },
  },
  "buyer_company": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "To",
      "isShownByDefault": true,
    },
  },
  "province": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Province",
      "width": 60,
      "isShownByDefault": true,
    },
  },
  "net_area_change_ha": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "ha",
    },
    "ui": {
      "label": "Net Area Change",
      "width": 100,
      "isShownByDefault": true,
    },
  },
  "petroninja_land_id_list": {
    "source": "regulator",
    "domainType": "object",
    "ui": {
      "label": "Land ID List",
      "isNotRenderable": true,
    },
  },
  "agreement_id_list": {
    "source": "regulator",
    "domainType": "object",
    "ui": {
      "label": "Agreement Id List",
      "isNotRenderable": true,
    },
  },
}
